import IconButton from '@mui/material/IconButton';
import { ReactComponent as CreateIcon } from '../assets/icons/main/pencil-ruler-icon.svg';
import { useTheme } from '@mui/material';

interface EditDigitalTwinTypes {
  onClick: () => void;
  disabled?: boolean;
}

const Styles = {
  icon: {
    cursor: 'pointer',
    height: '24px',
    width: '24px',
    color: '#51648F',
  },
};

const EditDigitalTwin = ({ onClick, disabled }: EditDigitalTwinTypes) => {
  const theme:any = useTheme();
  return (
    <IconButton onClick={onClick} disabled={disabled}>
      <CreateIcon style={{ ...Styles.icon, opacity: disabled ? 0.5 : 1, color : theme.palette.custom.light  }}  />
    </IconButton>
  );
};

export default EditDigitalTwin;
